import React from "react"
import autobind from "class-autobind"
import { Dialog, FlatButton, TextField, Toggle, Tabs, Tab } from "material-ui"
import strings from "../../../../localization/strings"
import { EScheduledJobType, EScheduledJobVersion, IScheduledJob } from "../../../../models/data/account/settings/IScheduledJob"
import * as utils from "../../../../helpers/utils"
import ScriptCodeEditor from "../../../../components/common/script_code_editor/ScriptCodeEditor"
import * as api from "../../../../api"
import AccountStore from "../../../../stores/AccountStore"
import AppStateStore from "../../../../stores/AppStateStore"
import { blue500, red500, green500 } from "material-ui/styles/colors"
import { checkJobFieldAvailable } from "../../../../helpers/jobHelper"
import ScheduledJobForm from "./forms/ScheduledJobForm"
import * as permissionHelper from "../../../../helpers/permissionHelper"
import AuthenticationStore from "../../../../stores/AuthenticationStore"

interface IProps {
    hideSystemToggle?: boolean
    hideAllowClientViewingToggle?: boolean
    hideCron?: boolean
    editScheduledJob: IScheduledJob
    type: EScheduledJobType
    handleClose(): void
    handleAdd(punchRule: IScheduledJob): void
    handleUpdate(punchRule: IScheduledJob): void
}

interface IState {
    id: string
    qaId: string
    name: string
    cron: string
    qaCron: string
    errorName: string
    scriptCode: string
    qaScript: boolean
    quailityAssuranceCode: string
    formData: string
    formDataJSON: string
    errorScriptCode: string
    compileScriptErrors: boolean
    compileScriptErrorsText: string
    errorQAScriptCode: string;
    compileQAScriptErrors: boolean;
    compileQAScriptErrorsText: string;
    longRunning: boolean
    description: string
    loomVideoURL: string
    loomVideoTranscript: string
    mondayURL: string
    businessRequirements: string
    didiDescription: string
    category: string
    emails: string
    qaEmails: string
    inprocess: boolean
    enabled: boolean
    system: boolean
    allowClientViewing: boolean
    readOnly: boolean
    llmTraining: boolean
    tabActive: string
}

export default class AddScheduleJobDialog extends React.Component<IProps, IState> {
    constructor(props: IProps) {
        super(props)
        if(props.editScheduledJob){
            if(props.editScheduledJob.CurrentQAScript){
                this.state = {
                    id: props.editScheduledJob ? props.editScheduledJob.Id : "",
                    qaId: props.editScheduledJob ? props.editScheduledJob.QAId : "",
                    name: props.editScheduledJob ? props.editScheduledJob.Name : "",
                    category: props.editScheduledJob ? props.editScheduledJob.Category : "",
                    cron: props.editScheduledJob ? props.editScheduledJob.CronExpression : "",
                    qaCron: props.editScheduledJob ? props.editScheduledJob.QACronExpression : "",
                    errorName: "",
                    qaScript: props.editScheduledJob ? props.editScheduledJob.QAScript : false,
                    scriptCode: props.editScheduledJob ? props.editScheduledJob.CurrentScript.CSharpCode : "",
                    quailityAssuranceCode: props.editScheduledJob ? props.editScheduledJob.CurrentQAScript.CSharpCode : "",
                    formData: props.editScheduledJob ? props.editScheduledJob.CurrentScript.FormData : "",
                    formDataJSON: props.editScheduledJob ? props.editScheduledJob.CurrentScript.FormDataJSON : "",
                    emails: props.editScheduledJob ? (props.editScheduledJob.StandardJobVariables ? props.editScheduledJob.StandardJobVariables.EmailList : "") : "",
                    qaEmails: props.editScheduledJob ? (props.editScheduledJob.StandardJobVariables ? props.editScheduledJob.StandardJobVariables.QAEmailList : "") : "",
                    errorScriptCode: "",
                    compileScriptErrors: false,
                    compileScriptErrorsText: "",
                    errorQAScriptCode: "",
                    compileQAScriptErrors: false,
                    compileQAScriptErrorsText: "",
                    description: props.editScheduledJob ? props.editScheduledJob.Description : "",
                    loomVideoURL: props.editScheduledJob ? props.editScheduledJob.LoomDetails.LoomVideoURL : "",
                    loomVideoTranscript: props.editScheduledJob ? props.editScheduledJob.LoomDetails.LoomVideoTranscript : "",
                    mondayURL: props.editScheduledJob ? props.editScheduledJob.MondayDetails.MondayURL : "",
                    businessRequirements: props.editScheduledJob ? props.editScheduledJob.BusinessRequirement.BusinessRequirement : "",
                    didiDescription: props.editScheduledJob ? props.editScheduledJob.BusinessRequirement.DiDiDescription : "",
                    longRunning: props.editScheduledJob ? props.editScheduledJob.LongRunning : true,
                    inprocess: props.editScheduledJob ? props.editScheduledJob.InProcess : false,
                    enabled: props.editScheduledJob ? props.editScheduledJob.Enabled : true,
                    system: props.editScheduledJob ? props.editScheduledJob.System : false,
                    allowClientViewing: props.editScheduledJob ? props.editScheduledJob.CanClientView : false,
                    readOnly: props.editScheduledJob ? props.editScheduledJob.ReadOnly : false,
                    llmTraining: props.editScheduledJob ? props.editScheduledJob.LLMTraining : false,
                    tabActive: "script",
                };
            }
            else{
                this.state = {
                    id: props.editScheduledJob ? props.editScheduledJob.Id : "",
                    qaId: props.editScheduledJob ? props.editScheduledJob.QAId : "",
                    name: props.editScheduledJob ? props.editScheduledJob.Name : "",
                    category: props.editScheduledJob ? props.editScheduledJob.Category : "",
                    cron: props.editScheduledJob ? props.editScheduledJob.CronExpression : "",
                    qaCron: props.editScheduledJob ? props.editScheduledJob.QACronExpression : "",
                    errorName: "",
                    qaScript: props.editScheduledJob ? props.editScheduledJob.QAScript : false,
                    scriptCode: props.editScheduledJob ? props.editScheduledJob.CurrentScript.CSharpCode : "",
                    quailityAssuranceCode: "",
                    formData: props.editScheduledJob ? props.editScheduledJob.CurrentScript.FormData : "",
                    formDataJSON: props.editScheduledJob ? props.editScheduledJob.CurrentScript.FormDataJSON : "",
                    emails: props.editScheduledJob ? (props.editScheduledJob.StandardJobVariables ? props.editScheduledJob.StandardJobVariables.EmailList : "") : "",
                    qaEmails: props.editScheduledJob ? (props.editScheduledJob.StandardJobVariables ? props.editScheduledJob.StandardJobVariables.QAEmailList : "") : "",
                    errorScriptCode: "",
                    compileScriptErrors: false,
                    compileScriptErrorsText: "",
                    errorQAScriptCode: "",
                    compileQAScriptErrors: false,
                    compileQAScriptErrorsText: "",
                    description: props.editScheduledJob ? props.editScheduledJob.Description : "",
                    loomVideoURL: "",
                    loomVideoTranscript:  "",
                    mondayURL: "",
                    businessRequirements: "",
                    didiDescription: "",
                    longRunning: props.editScheduledJob ? props.editScheduledJob.LongRunning : true,
                    inprocess: props.editScheduledJob ? props.editScheduledJob.InProcess : false,
                    enabled: props.editScheduledJob ? props.editScheduledJob.Enabled : true,
                    system: props.editScheduledJob ? props.editScheduledJob.System : false,
                    allowClientViewing: props.editScheduledJob ? props.editScheduledJob.CanClientView : false,
                    readOnly: props.editScheduledJob ? props.editScheduledJob.ReadOnly : false,
                    llmTraining: props.editScheduledJob ? props.editScheduledJob.LLMTraining : false,
                    tabActive: "script",
                };    
            }
        }
        else{
            this.state = {
                id: "",
                qaId: "",
                name: "",
                category: "",
                cron: "",
                qaCron: "",
                errorName: "",
                scriptCode: "",
                quailityAssuranceCode: "",
                formData: "",
                formDataJSON: "",
                emails: "",
                qaEmails: "",
                errorScriptCode: "",
                qaScript: false,
                compileScriptErrors: false,
                compileScriptErrorsText: "",
                errorQAScriptCode: "",
                compileQAScriptErrors: false,
                compileQAScriptErrorsText: "",
                description: "",
                loomVideoURL: "",
                loomVideoTranscript: "",
                mondayURL: "",
                businessRequirements: "",
                didiDescription: "",
                longRunning: true,
                inprocess: false,
                enabled: true,
                system: false,
                allowClientViewing: false,
                readOnly: false,
                llmTraining: false,
                tabActive: "script",
            };
        }
 
        autobind(this)

    }

    handleSave() {
        if (!this.checkValidate()) return
        AppStateStore.setProgressSnackbarContent("loading")
        const payload: IScheduledJob = this.getPayload()
        const isGlobalAdmin = permissionHelper.isGlobalAdmin();
        const compileCheck = isGlobalAdmin
            ? api.compileCheckScheduledJob(AccountStore.getCurrentAccount().Id, payload)
            : Promise.resolve({ data: "" }); // Skip compile check for non-global admins
        compileCheck.then(res =>
            res.data.length !== 0 ?
                this.setState({
                    compileScriptErrors: true,
                    compileScriptErrorsText: res.data,
                }, () => AppStateStore.setProgressSnackbarContent(null)) :
                this.props.editScheduledJob ?
                    this.props.handleUpdate(payload) :
                    this.props.handleAdd(payload)
        )
    }

    getPayload() {
        const payload: IScheduledJob = {
            Id: this.props.editScheduledJob ? this.props.editScheduledJob.Id : utils.guid(),
            QAId: this.props.editScheduledJob ? this.props.editScheduledJob.QAId : null,
            AccountId: this.props.editScheduledJob ? this.props.editScheduledJob.AccountId : AccountStore.getCurrentAccount().Id,
            AverageMinutesToFinish: this.props.editScheduledJob ? this.props.editScheduledJob.AverageMinutesToFinish : 0,
            Name: this.state.name.trim(),
            Category: this.state.category ? this.state.category.trim() : null,
            QAScript: this.state.qaScript,
            CronExpression: this.state.cron ? this.state.cron.trim() : null,
            QACronExpression: this.state.qaCron ? this.state.qaCron.trim() : null,
            CurrentScript: {
                ScriptStartRunTime: null,
                CSharpCode: this.state.scriptCode ? this.state.scriptCode.trim() : null,
                FormData: this.state.formData ? this.state.formData.trim() : null,
                FormDataJSON: this.state.formDataJSON ? this.state.formDataJSON.trim() : null,
                DiffWithPreviousHtml: "",
                Version: 0,
                ScriptLogs: [],
                ObjectAudit: null,
            },
            CurrentQAScript: {
                ScriptStartRunTime: null,
                CSharpCode: this.state.quailityAssuranceCode
                ? this.state.quailityAssuranceCode.trim()
                : (this.props.editScheduledJob && this.props.editScheduledJob.CurrentQAScript
                    ? this.props.editScheduledJob.CurrentQAScript.CSharpCode || ""
                    : ""),
                FormData: this.state.formData ? this.state.formData.trim() : null,
                FormDataJSON: this.state.formDataJSON ? this.state.formDataJSON.trim() : null,
                DiffWithPreviousHtml: "",
                Version: 0,
                ScriptLogs: [],
                ObjectAudit: null,
            },
            LastRunTime: null,
            NextRunTime: null,
            ShowDiff: false,
            ShowLog: false,
            LongRunning: this.state.longRunning,
            Description: this.state.description,
            LoomDetails: {
                LoomVideoURL: this.state.loomVideoURL ? this.state.loomVideoURL : null,
                LoomVideoTranscript: this.state.loomVideoTranscript ? this.state.loomVideoTranscript : null,
            },
            BusinessRequirement: {
                BusinessRequirement: this.state.businessRequirements ? this.state.businessRequirements : null,
                DiDiDescription: this.state.didiDescription ? this.state.didiDescription : null,
                IsFromMonday: this.props.editScheduledJob && this.props.editScheduledJob.BusinessRequirement
                    ? this.props.editScheduledJob.BusinessRequirement.IsFromMonday 
                    : false,
                LastModifiedDate: this.props.editScheduledJob && this.props.editScheduledJob.BusinessRequirement
                    ? this.props.editScheduledJob.BusinessRequirement.LastModifiedDate
                    : null,
                LastModifiedByName: this.props.editScheduledJob && this.props.editScheduledJob.BusinessRequirement
                    ? this.props.editScheduledJob.BusinessRequirement.LastModifiedByName
                    : null,
            },
            MondayDetails: {
                MondayURL: this.state.mondayURL ? this.state.mondayURL : null,
            },
            LLMTraining: this.state.llmTraining,
            InProcess: this.state.inprocess,
            Enabled: this.state.enabled,
            System: this.state.system,
            AccountName: this.props.editScheduledJob ? this.props.editScheduledJob.AccountName : null,
            CanClientView: this.state.allowClientViewing,
            ReadOnly: this.state.readOnly,
            Type: this.props.type,
            Version: this.props.editScheduledJob ? this.props.editScheduledJob.Version : EScheduledJobVersion.V2,
            StandardJobVariables: {
                EmailList: this.state.emails,
                QAEmailList: this.state.qaEmails,
            }                     
        }
        return payload
    }

    handleCompile() {
        api.compileCheckScheduledJob(AccountStore.getCurrentAccount().Id, this.getPayload()).then(res => {
            res.data.length !== 0 ?
                this.setState({
                    compileScriptErrors: true,
                    compileScriptErrorsText: res.data,
                }) :
                this.setState({
                    compileScriptErrors: false,
                    compileScriptErrorsText: "",
                })
        })
    }

    handleQACompile() {
        api.qaCompileCheckScheduledJob(AccountStore.getCurrentAccount().Id, this.getPayload()).then(res => {
            res.data.length !== 0 ?
                this.setState({
                    compileQAScriptErrors: true,
                    compileQAScriptErrorsText: res.data,
                }) :
                this.setState({
                    compileQAScriptErrors: false,
                    compileQAScriptErrorsText: "",
                })
        })
    }
    

    checkValidate() {
        const isGlobalAdmin = permissionHelper.isGlobalAdmin();
        let isValidate = true
        if (!this.state.name.trim()) {
            this.setState({ errorName: strings.NameRequired })
            isValidate = false
        }
        else {
            this.setState({ errorName: "" })
        }
        if (isGlobalAdmin) {
            if (!this.state.scriptCode.trim()) {
                this.setState({ errorScriptCode: strings.This_field_is_required })
                isValidate = false
            }
            else {
                this.setState({ errorScriptCode: "" })
            }
        }
        return isValidate
    }


    render() {
        const isGlobalAdmin = permissionHelper.isGlobalAdmin() ||
            (
                AuthenticationStore.getLoggedInAccountManagerUser() ?
                    permissionHelper.hasAccountManagerPermission(AuthenticationStore.AccountManagerUserPermissions.Clients.AccountScheduledJob) :
                    false
            )
            console.log()
        return (
            <Dialog
                open
                fullScreen
                title={checkJobFieldAvailable('singular') ? `Scheduled ${AccountStore.getCurrentAccountSettings().CustomFieldSettings.JobFieldLabels.SingularJobLabel}` :strings.Scheduled_job}
                titleStyle={{ paddingLeft: 35, paddingBottom: 10 }}
                contentStyle={{ width: "95%", maxWidth: "none" }}
                autoScrollBodyContent
                actions={[
                    <FlatButton
                        data-intercom-target={"menu-AccountSettings-ScheduledJobs-Btn-CloseAddScheduleJobDialog"}
                        label={strings.CANCEL}
                        secondary
                        onClick={this.props.handleClose}
                    />,
                    <FlatButton
                        data-intercom-target={"menu-AccountSettings-ScheduledJobs-Btn-SaveScheduleJob"}
                        label={strings.SAVE}
                        primary
                        onClick={this.handleSave}
                    />
                ]}
            >
                <div style={{ paddingRight: 20, paddingLeft: 20 }}>
                    <div style={{ display: "flex" }}>
                        <TextField
                            data-intercom-target={"menu-AccountSettings-ScheduledJobs-Add-Entry-Name"}
                            fullWidth
                            style={{ marginRight: 50 }}
                            floatingLabelText={strings.Name}
                            value={this.state.name}
                            onChange={(e, value) => { this.setState({ name: value }, () => this.checkValidate()) }}
                            errorText={this.state.errorName}
                            errorStyle={{ position: "absolute", bottom: -10 }}
                            disabled={!isGlobalAdmin}
                        />
                        {!this.props.hideCron &&
                            <TextField
                                data-intercom-target={"menu-AccountSettings-ScheduledJobs-Add-Entry-CronExpression"}
                                fullWidth
                                style={{ marginRight: 50 }}
                                floatingLabelText={this.state.qaScript ? "QA Findd Script Cron" : "Findd Script Cron"}
                                value={this.state.cron}
                                onChange={(e, value) => { this.setState({ cron: value }, () => this.checkValidate()) }}
                                errorStyle={{ position: "absolute", bottom: -10 }}
                                disabled={!isGlobalAdmin}
                            />
                        }
                        
                    </div>
                    <div style={{ display: "flex" }}>
                        <TextField
                            data-intercom-target={"menu-AccountSettings-ScheduledJobs-Add-Entry-Description"}
                            fullWidth
                            style={{ marginRight: 50 }}
                            floatingLabelText={strings.Description}
                            value={this.state.description}
                            onChange={(e, value) => { this.setState({ description: value }, () => this.checkValidate()) }}
                            errorStyle={{ position: "absolute", bottom: -10 }}
                            disabled={!isGlobalAdmin}
                        />
                        <TextField
                            data-intercom-target={"menu-AccountSettings-ScheduledJobs-Add-Entry-Category"}
                            fullWidth
                            style={{ marginRight: 50 }}
                            floatingLabelText={"Category"}
                            value={this.state.category}
                            onChange={(e, value) => { this.setState({ category: value }, () => this.checkValidate()) }}
                            errorStyle={{ position: "absolute", bottom: -10 }}
                            disabled={!isGlobalAdmin}
                        />                        
                    </div>
                    {!this.state.qaScript && isGlobalAdmin &&  
                        <div style={{ display: "flex" }}>
                            <TextField
                                //data-intercom-target={"menu-AccountSettings-ScheduledJobs-Add-Entry-Description"}
                                fullWidth
                                style={{ marginRight: 50 }}
                                floatingLabelText={"Loom Video URL"}
                                value={this.state.loomVideoURL}
                                onChange={(e, value) => { this.setState({ loomVideoURL: value }, () => this.checkValidate()) }}
                                errorStyle={{ position: "absolute", bottom: -10 }}
                            />
                            <TextField
                                //data-intercom-target={"menu-AccountSettings-ScheduledJobs-Add-Entry-Category"}
                                fullWidth
                                style={{ marginRight: 50 }}
                                floatingLabelText={"Monday URL"}
                                value={this.state.mondayURL}
                                onChange={(e, value) => { this.setState({ mondayURL: value }, () => this.checkValidate()) }}
                                errorStyle={{ position: "absolute", bottom: -10 }}
                            />                        
                        </div>
                    }
                    <div style={{ display: "flex" }}>
                        <TextField
                            data-intercom-target={"menu-AccountSettings-ScheduledJobs-Add-Entry-Email"}
                            fullWidth
                            style={{ marginRight: 50 }}
                            floatingLabelText="Comma-Delimited Email List for Findd Script"
                            value={this.state.emails}
                            onChange={(e, value) => { this.setState({ emails: value }, () => this.checkValidate()) }}
                            errorStyle={{ position: "absolute", bottom: -10 }}
                        />
                    {isGlobalAdmin && (
                        this.state.qaScript ? (
                            <TextField
                                //data-intercom-target={"menu-AccountSettings-ScheduledJobs-Add-Entry-Category"}
                                fullWidth
                                style={{ marginRight: 50 }}
                                floatingLabelText={"QA Job ID"}
                                disabled
                                value={this.state.id}
                                errorStyle={{ position: "absolute", bottom: -10 }}
                            />
                        ) : (
                            <TextField
                                //data-intercom-target={"menu-AccountSettings-ScheduledJobs-Add-Entry-Category"}
                                fullWidth
                                style={{ marginRight: 50 }}
                                floatingLabelText={"QA Scheduled Job ID"}
                                value={this.state.qaId}
                                onChange={(e, value) => { this.setState({ qaId: value }, () => this.checkValidate()) }}
                                errorStyle={{ position: "absolute", bottom: -10 }}
                            />
                        )
                    )}
             
                    </div>   
                    {isGlobalAdmin && (           
                    <div style={{ display: "flex" }}>
                        <Toggle
                            data-intercom-target={"menu-AccountSettings-ScheduledJobs-Add-Toggle-Enabled"}
                            label={strings.Enabled}
                            style={{ width: 100, marginTop: 5 }}
                            toggled={this.state.enabled}
                            onToggle={(e, value) => this.setState({ enabled: value })}
                        />
                        
                        {!this.props.hideSystemToggle &&
                            <Toggle
                                data-intercom-target={"menu-AccountSettings-ScheduledJobs-Add-Toggle-System"}
                                label={strings.System}
                                style={{ width: 100, marginTop: 5, marginLeft: 50 }}
                                toggled={this.state.system}
                                onToggle={(e, value) => this.setState({ system: value })}
                            />
                        }
                        
                        <Toggle
                            //data-intercom-target={"menu-AccountSettings-ScheduledJobs-Add-Toggle-LongRunning"}
                            label="Findd QA Script"
                            style={{ width: 175, marginTop: 5, marginLeft: 50 }}
                            toggled={this.state.qaScript}
                            onToggle={(e, value) => {
                                this.setState({ qaScript: value, qaId: "" });
                            }} 
                        />
                        <Toggle
                            data-intercom-target={"menu-AccountSettings-ScheduledJobs-Add-Toggle-LongRunning"}
                            label={strings.LongRunning}
                            style={{ width: 150, marginTop: 5, marginLeft: 50 }}
                            toggled={this.state.longRunning}
                            onToggle={(e, value) => this.setState({ longRunning: value })}
                        />
                        {!this.props.hideAllowClientViewingToggle &&
                            <Toggle
                                data-intercom-target={"menu-AccountSettings-ScheduledJobs-Add-Toggle-AllowClientViewing"}
                                label={strings.Allow_Client_Viewing}
                                style={{ width: 200, marginTop: 5, marginLeft: 50 }}
                                toggled={this.state.allowClientViewing}
                                onToggle={(_e, value) => this.setState({ allowClientViewing: value })}
                            />
                        }
                        <Toggle
                            //data-intercom-target={"menu-AccountSettings-ScheduledJobs-Add-Toggle-AllowClientViewing"}
                            label="Read Only"
                            style={{ width: 125, marginTop: 5, marginLeft: 50 }}
                            toggled={this.state.readOnly}
                            onToggle={(_e, value) => this.setState({ readOnly: value })}
                        />
                        <Toggle
                            //data-intercom-target={"menu-AccountSettings-ScheduledJobs-Add-Toggle-AllowClientViewing"}
                            label="DiDi Training"
                            style={{ width: 150, marginTop: 5, marginLeft: 50 }}
                            toggled={this.state.llmTraining}
                            onToggle={(_e, value) => this.setState({ llmTraining: value })}
                        />
                    
                    </div>
                    )}

                    <Tabs value={this.state.tabActive} onChange={tabActive => this.setState({ tabActive })} style={{marginTop: 20}}>
                    {isGlobalAdmin && (  
                        <Tab label={this.state.qaScript ? "QA Findd Script" : "Findd Script"} value="script">
                            <div>
                                <div style={{ marginTop: 20 }}>
                                    <FlatButton
                                        data-intercom-target={"menu-AccountSettings-ScheduledJobs-Add-Btn-Compile"}
                                        label={strings.Compile}
                                        onClick={this.handleCompile}
                                        style={{ backgroundColor: blue500, color: "#ffffff" }}
                                    />
                                </div>
                                {this.state.compileScriptErrors &&
                                    <div style={{ color: red500 }}>
                                        <pre>{this.state.compileScriptErrorsText}</pre>
                                    </div>
                                }
                                {!this.state.compileScriptErrors &&
                                    <div style={{ color: green500, marginTop: 15 }}>
                                        <i className="fa fa-check" style={{ fontSize: 15, color: green500, fontWeight: "bold" }} /> {strings.NoCompileError}
                                    </div>
                                }
                                <ScriptCodeEditor
                                    scriptCode={this.state.scriptCode}
                                    errorScriptCode={this.state.errorScriptCode}
                                    handleChange={scriptCode => this.setState({ scriptCode }, () => this.checkValidate())}
                                />
                            </div>
                        </Tab>
                    )}
                       
                        <Tab label="Job Variables" value="variables">
                            <ScheduledJobForm formJSON={this.state.formDataJSON} setFormData={formData => this.setState({ formData })} formData={this.state.formData}/>
                        </Tab>
                        {isGlobalAdmin && (
                        <Tab label="Form Data" value="form-data">
                            <ScriptCodeEditor
                                scriptCode={this.state.formDataJSON || ""}
                                errorScriptCode={""}
                                handleChange={formDataJSON => this.setState({ formDataJSON }, () => this.checkValidate())}
                                scriptLabel="Form Data"
                            />
                        </Tab>
                        )}
                        {isGlobalAdmin && !this.state.qaScript &&
                            <Tab label="Loom Transcript" value="loomVideoTranscript">
                                <div style={{ display: "flex" }}>
                                    <TextField
                                        fullWidth={true}
                                        multiLine={true}
                                        rows={5}
                                        floatingLabelText="Copy and Past Loom Video Transcript Here"
                                        value={this.state.loomVideoTranscript}
                                        onChange={(e) => { this.setState({ loomVideoTranscript: e.target.value }, () => this.checkValidate()) }}
                                        errorStyle={{ position: "absolute", bottom: -10 }}
                                    />                 
                                </div>       
                            </Tab>
                        }
                        {!this.state.qaScript &&
                            <Tab label="Business Requirements" value="businessRequirements">
                                <div style={{ width: "99%", margin: "0 auto" }}>
                                    <TextField
                                        //data-intercom-target={"menu-AccountSettings-ScheduledJobs-Add-Entry-Email"}
                                        fullWidth
                                        style={{ marginRight: 50 }}
                                        floatingLabelText="DiDi Description"
                                        value={this.state.didiDescription}
                                        onChange={(e, value) => { this.setState({ didiDescription: value }, () => this.checkValidate()) }}
                                        errorStyle={{ position: "absolute", bottom: -10 }}
                                        disabled={!isGlobalAdmin}
                                    />
                                    <TextField
                                        fullWidth={true}
                                        multiLine={true}
                                        rows={5}
                                        floatingLabelText="Business Requirements"
                                        value={this.state.businessRequirements}
                                        onChange={(e) => { this.setState({ businessRequirements: e.target.value }, () => this.checkValidate()) }}
                                        errorStyle={{ position: "absolute", bottom: -10 }}
                                        disabled={!isGlobalAdmin}
                                    />     
                                </div>
                            </Tab>               
                        }                           
                    </Tabs>
                </div>
            </Dialog >
        )
    }
}